export default popup => popup.type === 'image';



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isImagePopup.jsx